var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "c-object",
      attrs: { "data-type": `Object`, "data-name": _vm.title },
    },
    [
      _c("a", { attrs: { href: _vm.url } }, [
        _c("span", { staticClass: "t-visually-hidden" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
      ]),
      _vm._v(" "),
      _vm.finalGalleryImages.length > 0
        ? _c("v-gallery", {
            attrs: {
              images: _vm.transformedGalleryImages,
              "step-length": 1,
              "premise-types": _vm.normalizedPremiseTypes,
              "icon-label": _vm.iconLabel,
              title: _vm.title,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "c-object__content" }, [
        _vm.address
          ? _c("p", { staticClass: "c-object__title" }, [
              _vm._v(_vm._s(_vm.address)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.fixedSize
          ? _c("p", { staticClass: "c-object__byline" }, [
              _vm._v(_vm._s(_vm.fixedSize)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.selectedFeatures && _vm.selectedFeatures.length > 0
          ? _c(
              "div",
              { staticClass: "c-object__icons" },
              [
                _vm._l(_vm.selectedFeatures, function (feature) {
                  return _c(
                    "span",
                    {
                      key: feature.Icon,
                      staticClass: "c-object__icon-wrapper",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "c-icon c-icon--xs c-object__icon",
                          attrs: { "aria-hidden": "true" },
                        },
                        [
                          _c("svg", [
                            _c("use", {
                              attrs: { "xlink:href": "#icon-" + feature.Icon },
                            }),
                          ]),
                        ]
                      ),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.overflowFeaturesCount > 0
                  ? _c("span", { staticClass: "c-object__icon-wrapper" }, [
                      _c("span", { staticClass: "c-object__icons-more" }, [
                        _vm._v("+" + _vm._s(_vm.overflowFeaturesCount)),
                      ]),
                    ])
                  : _vm._e(),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.title
          ? _c("p", { staticClass: "c-object__info-text" }, [
              _vm._v(_vm._s(_vm.title)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.workplaceDisplay || _vm.priceDisplay
          ? _c("div", { staticClass: "c-object__info-boxes" }, [
              _vm.workplaceDisplay
                ? _c("div", { staticClass: "c-object__info-box" }, [
                    _c("i", {
                      staticClass:
                        "fa-regular fa-users c-object__info-box-icon",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "c-object__info-box-text" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.workplaceDisplay) +
                          " st\n        "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.priceDisplay > 0
                ? _c("div", { staticClass: "c-object__info-box" }, [
                    _c("i", {
                      staticClass:
                        "fa-regular fa-building c-object__info-box-icon",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "c-object__info-box-text" }, [
                      _vm._v(
                        "\n          " + _vm._s(_vm.priceDisplay) + "\n        "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }